var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherDarkgray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2504 24.5824H41.1529C40.2332 21.0202 38.3327 17.7875 35.6675 15.2515C33.0023 12.7155 29.6791 10.9779 26.0757 10.2362C22.4723 9.4945 18.7331 9.77839 15.283 11.0556C11.8329 12.3329 8.81017 14.5522 6.55837 17.4615C4.30657 20.3708 2.91595 23.8534 2.54454 27.5136C2.17313 31.1737 2.83581 34.8647 4.45729 38.167C6.07877 41.4694 8.59403 44.2507 11.7173 46.195C14.8405 48.1392 18.4464 49.1685 22.1254 49.1657H44.2504C47.5103 49.1657 50.6368 47.8707 52.9419 45.5656C55.2471 43.2604 56.5421 40.134 56.5421 36.874C56.5421 33.6141 55.2471 30.4877 52.9419 28.1825C50.6368 25.8774 47.5103 24.5824 44.2504 24.5824Z",
    stroke: "#858585",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1483 32.7687L31.7373 50.1491C31.5226 50.5209 31.4091 50.9423 31.4079 51.3716C31.4067 51.8008 31.5179 52.2229 31.7304 52.5958C31.943 52.9688 32.2495 53.2795 32.6195 53.4972C32.9894 53.7149 33.4099 53.8319 33.8392 53.8366H54.6612C55.0905 53.8319 55.511 53.7149 55.8809 53.4972C56.2509 53.2795 56.5574 52.9688 56.77 52.5958C56.9825 52.2229 57.0938 51.8008 57.0926 51.3716C57.0914 50.9423 56.9778 50.5209 56.7631 50.1491L46.3521 32.7687C46.133 32.4075 45.8244 32.1088 45.4563 31.9015C45.0881 31.6942 44.6727 31.5854 44.2502 31.5854C43.8277 31.5854 43.4123 31.6942 43.0442 31.9015C42.676 32.1088 42.3675 32.4075 42.1483 32.7687Z",
    fill: "#E6E6E6",
    stroke: "#858585",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 39.0871V44.0038",
    stroke: "#858585",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 48.9195H44.2615",
    stroke: "#858585",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherDarkgray);
export default __webpack_public_path__ + "static/media/weatherDarkgray.4c5dae1dbbc950f1bb8019fbb927ad7b.svg";
export { ForwardRef as ReactComponent };